import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgLocalization = (props: SvgProps) => (
  <Svg fill="none" height={41} width={41} {...props}>
    <Path
      clipRule="evenodd"
      d="m30.935 40.5-5.533-29.565L.5 13.203v20.124c0 2.51 0 3.766.488 4.725a4.48 4.48 0 0 0 1.954 1.96c.958.488 2.21.488 4.715.488zm-9.188-13.382c0 4.837-4.786 8.235-6.873 9.488a1.85 1.85 0 0 1-1.91 0c-2.087-1.253-6.873-4.65-6.873-9.49 0-4.745 3.794-7.91 7.828-7.91 4.176 0 7.828 3.165 7.828 7.912"
      fill="#FDCECE"
      fillRule="evenodd"
    />
    <Path
      d="M.984 2.927C.5 3.88.5 5.124.5 7.613v1.365L40.478 5.34c-.042-1.084-.156-1.809-.462-2.414A4.45 4.45 0 0 0 38.073.985C37.123.5 35.878.5 33.39.5H7.61C5.122.5 3.878.5 2.927.985A4.45 4.45 0 0 0 .984 2.927M40.5 9.805l-10.811.982L35.258 40.5c1.315-.029 2.14-.129 2.815-.474a4.45 4.45 0 0 0 1.943-1.942c.484-.952.484-2.196.484-4.686zM13.978 29.196a2.174 2.174 0 1 0 0-4.348 2.174 2.174 0 0 0 0 4.348"
      fill="#F49090"
    />
  </Svg>
);
const Memo = memo(SvgLocalization);
export default Memo;
